// extracted by mini-css-extract-plugin
export default {"text":"Christmas_text__b1CRY","img-container":"Christmas_img-container__ifpc+","hashtags":"Christmas_hashtags__XN33v","snowfall":"Christmas_snowfall__4PFzN"};